import {
  ftConfig,
  ftSpotlightGroup,
  ftSpotlightId,
  ftSpotlightName,
  gtagConfig,
  metaConfig,
  srConfig,
  tdConfig,
  tdPixels,
} from 'assets/data/trackingConfig';

export default defineNuxtPlugin({
  name: 'tracking',
  dependsOn: ['init-client', 'directives'],
  parallel: true,
  async setup() {
    const { $enabled } = useNuxtApp();
    const siteStore = useSiteStore();
    window.tracking = window.tracking || {
      flashtalking: {},
      tradedesk: {},
    };

    const runtimeConfig = useRuntimeConfig();

    // gtm
    useScript(
      {
        src: `/tracking/tagmanager.js?gtmScriptId=${runtimeConfig.public.tagManagerScriptId}`,
        async: true,
        defer: true,
      },
      {
        trigger: computed(() =>
          $enabled('tracking.enablegoogletagmanagertracking'),
        ),
      },
    );
    // ga
    useScript(
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${gtagConfig[siteStore.getRegionCode]}`,
        async: true,
        defer: true,
      },
      {
        trigger: computed(
          () =>
            $enabled('tracking.enablegoogleanalyticstracking') &&
            !!gtagConfig[siteStore.getRegionCode],
        ),
      },
    );
    useScript(
      {
        src: `/tracking/gtag.js?scriptId=${gtagConfig[siteStore.getRegionCode]}`,
        async: true,
        defer: true,
      },
      {
        trigger: computed(
          () =>
            $enabled('tracking.enablegoogleanalyticstracking') &&
            !!gtagConfig[siteStore.getRegionCode],
        ),
      },
    );

    // sport radar
    useScript(
      {
        src: `/tracking/sportradar.js?scriptId=${srConfig[siteStore.getRegionCode]}`,
        async: true,
        defer: true,
      },
      {
        tagPosition: 'bodyClose',
        trigger: computed(
          () =>
            $enabled('tracking.enablesportradartracking') &&
            !!srConfig[siteStore.getRegionCode],
        ),
      },
    );

    // tradedesk
    const td = useScript(
      {
        src: `/tracking/tradedesk.js?scriptId=${tdConfig[siteStore.getRegionCode]}&version=${siteStore.getRegion === 'GH' ? '3.0.0' : '1.1.0'}`,
        async: true,
        defer: true,
      },
      {
        tagPosition: 'bodyClose',
        trigger: computed(
          () =>
            $enabled('tracking.enabletradedesktracking') &&
            !!tdConfig[siteStore.getRegionCode],
        ),
      },
    );
    td.onLoaded(() => {
      window.tracking.tradedesk = window.tracking.tradedesk || {};
      window.tracking.tradedesk.pixel = tdPixels[siteStore.getRegionCode];
    });

    // flashtalking
    const ft = useScript(
      {
        src: `/tracking/flashtalking.js?scriptId=${ftConfig[siteStore.getRegionCode]}`,
        async: true,
        defer: true,
      },
      {
        tagPosition: 'bodyClose',
        trigger: computed(
          () =>
            $enabled('tracking.enableflashtalkingtracking') &&
            !!ftConfig[siteStore.getRegionCode],
        ),
      },
    );
    ft.onLoaded(() => {
      window.tracking.flashtalking = window.tracking.flashtalking || {};
      window.tracking.flashtalking.spotlight =
        ftSpotlightId[siteStore.getRegionCode];
      window.tracking.flashtalking.spotlightGroup =
        ftSpotlightGroup[siteStore.getRegionCode];
      window.tracking.flashtalking.spotlightName = ftSpotlightName;
    });

    //   opera
    useScript(
      {
        src: '/tracking/opera.js',
        async: true,
        defer: true,
      },
      {
        tagPosition: 'bodyClose',
        trigger: computed(() => $enabled('tracking.enableoperatracking')),
      },
    );

    // meta
    useScript(
      {
        src: `/tracking/meta.js?scriptId=${metaConfig[siteStore.getRegionCode]}`,
        async: true,
        defer: true,
      },
      {
        tagPosition: 'bodyClose',
        trigger: computed(
          () =>
            $enabled('tracking.enablemetatracking') &&
            !!metaConfig[siteStore.getRegionCode],
        ),
      },
    );
  },
});
